import {api} from "../../../api/API";
import {EditContext} from "../../../misc/scroller/EditProvider";
import {useContext} from "react";
import {FrameBuilder} from "../../manufacturing/FrameBuilder";

export function CreateStockingFrameProduct(props: {
    onDone(): void
}) {
    const edit = useContext(EditContext)

    return <FrameBuilder onCancel={props.onDone} components={true} onDone={async (p) => {
        p.isStocking = true;
        await api.products.upsert(p)

        edit.reload();
        props.onDone();
    }} />;
}